import { render, staticRenderFns } from "./wxacquisition.vue?vue&type=template&id=b71ec77c&scoped=true&"
import script from "./wxacquisition.vue?vue&type=script&lang=js&"
export * from "./wxacquisition.vue?vue&type=script&lang=js&"
import style0 from "./wxacquisition.vue?vue&type=style&index=0&id=b71ec77c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71ec77c",
  null
  
)

export default component.exports